import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import PaymentService from '../services/PaymentService';

const initialState = {
    data: null,
    datas: [],
    pagination: {
        page: 0,
        per_page: 10,
        total: 0,
        totalPages: 0,
    },
    error: null,
    status: '',
    loading: false,
    submitLoading: false,
    grand_total: 0,
};

export const paymentList = createAsyncThunk(
    'payment/list',
    async (payload) => {
        try {
            const resp = await PaymentService.List(payload);
            return resp;
        } catch (e) {
            return e.response;
        }
    },
);

export const paymentAdd = createAsyncThunk('payment/add', async ({ data, navigate }) => {
    try {
        const resp = await PaymentService.Create(data);
        if (resp?.status === 201 || resp?.status === 200) {
            const paymentId = resp?.data?.data?.id;
            if (paymentId) {
                navigate(`/payments/${paymentId}`);
            } else {
                navigate('/payments');
            }
        }
        return resp;
    } catch (e) {
        return e.response;
    }
});

export const paymentBulkAdd = createAsyncThunk('payment/bulkAdd', async ({ data, navigate }) => {
    try {
        const resp = await PaymentService.BulkCreate(data);
        if (resp?.status === 200) {
            navigate('/payments');
        }
        return resp;
    } catch (e) {
        return e.response;
    }
});

export const getPaymentDetail = createAsyncThunk('payment/detail', async ({ id }) => {
    try {
        const resp = await PaymentService.Detail(id);
        return resp;
    } catch (error) {
        return error.response;
    }
});

export const paymentUpdate = createAsyncThunk('payment/update', async ({ id, data, navigate }) => {
    try {
        const resp = await PaymentService.Update(id, data);
        if (resp?.status === 200) {
            if (navigate) {
                navigate(`/payments/${id}`);
            }
        }
        return resp;
    } catch (e) {
        return e.response;
    }
});

const paymentAction = createSlice({
    name: 'payment',
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(paymentList.pending, (state) => {
                state.loading = true;
            })
            .addCase(paymentList.fulfilled, (state, action) => {
                if (action.payload?.status === 200) {
                    state.datas = [...action.payload?.data?.data?.payments];
                    state.pagination = action.payload?.data?.data?.pagination;
                    state.grand_total = action.payload?.data?.data?.grand_total || 0;
                } else {
                    state.error = action.payload?.data?.message;
                    toast.error(state.error);
                }
                state.loading = false;
            })
            .addCase(paymentList.rejected, (state, action) => {
                state.error = action.payload?.data;
                state.loading = false;
            })
            .addCase(paymentAdd.pending, (state) => {
                state.submitLoading = true;
            })
            .addCase(paymentAdd.fulfilled, (state, action) => {
                if (action.payload?.status === 200 || action.payload?.status === 201) {
                    state.status = 'achieve';
                    toast.success(action.payload?.data?.message);
                } else {
                    toast.error(action.payload?.data?.message);
                }
                state.submitLoading = false;
            })
            .addCase(paymentAdd.rejected, (state, action) => {
                state.error = action.payload?.data;
                state.submitLoading = false;
            })
            .addCase(paymentBulkAdd.pending, (state) => {
                state.submitLoading = true;
            })
            .addCase(paymentBulkAdd.fulfilled, (state, action) => {
                if (action.payload?.status === 200) {
                    state.status = 'achieve';
                    toast.success(action.payload?.data?.message);
                } else {
                    toast.error(action.payload?.data?.message);
                }
                state.submitLoading = false;
            })
            .addCase(paymentBulkAdd.rejected, (state, action) => {
                state.error = action.payload?.data;
                state.submitLoading = false;
            })
            .addCase(getPaymentDetail.pending, (state) => {
                state.loading = true;
            })
            .addCase(getPaymentDetail.fulfilled, (state, action) => {
                if (action.payload?.status === 200) {
                    state.data = action.payload?.data?.data;
                } else {
                    toast.error(action.payload?.data?.message);
                }
                state.loading = false;
            })
            .addCase(getPaymentDetail.rejected, (state, action) => {
                state.error = action.payload?.data;
                state.loading = false;
            })
            .addCase(paymentUpdate.pending, (state) => {
                state.submitLoading = true;
            })
            .addCase(paymentUpdate.fulfilled, (state, action) => {
                if (action.payload?.status === 200) {
                    state.status = 'achieve';
                    state.data = action.payload?.data?.data;
                    toast.success(action.payload?.data?.message);
                } else {
                    toast.error(action.payload?.data?.message);
                }
                state.submitLoading = false;
            })
            .addCase(paymentUpdate.rejected, (state, action) => {
                state.error = action.payload?.data;
                state.submitLoading = false;
            });
    },
});

const { reducer } = paymentAction;
export const paymentSelector = (state) => state.payment;
export default reducer;
